import { useQuery } from '@tanstack/react-query';
import { getPortalAccount } from '@api/customer-portal-api';
import { queryKeys } from '@hooks/queryKeys';

export const useAccount = () =>
  useQuery({
    queryKey: queryKeys.account.all,
    queryFn: () => getPortalAccount(),
  });
